import { render } from "./Roger.html?vue&type=template&id=7ff42aa4&scoped=true&ts=true&external"
import script from "./Roger.ts?vue&type=script&lang=ts&external"
export * from "./Roger.ts?vue&type=script&lang=ts&external"

import "./Roger.css?vue&type=style&index=0&id=7ff42aa4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff42aa4"]])

export default __exports__